import { Component } from 'react';

import { MewsImage } from '@mews/business-components';
import { ImageResizeMode } from '@mews/enums';
import { RouterService } from '@mews/framework';

import { IMAGE_DEFAULT_QUALITY, IMAGE_DEFAULT_RATIO, IMAGE_DEFAULT_SIZES } from './constants';

interface OwnProps {
    id?: string;
    mode?: ImageResizeMode;
    imageSizeType?: unknown;
    imageBaseUrl?: string;
    grayscale?: boolean;
    ratio?: number;
    sizes?: string;
    quality?: number;
}

interface State {
    minHeight?: number;
}

type Props = OwnProps & typeof defaultProps;

const defaultProps = {
    ratio: IMAGE_DEFAULT_RATIO,
    sizes: IMAGE_DEFAULT_SIZES,
    quality: IMAGE_DEFAULT_QUALITY,
};

export class ServerImage extends Component<Props, State> {
    static defaultProps = defaultProps;

    state = { minHeight: undefined };
    private placeholderElement: HTMLDivElement | null = null;

    componentDidMount() {
        this.setPlaceholderHeight();
    }

    setPlaceholderHeight() {
        if (this.placeholderElement?.parentElement) {
            const { ratio } = this.props;
            const parentWidth = this.placeholderElement.parentElement.clientWidth;

            this.setState({ minHeight: parentWidth / ratio });
        }
    }

    handleImageRef = (element: HTMLDivElement | null) => {
        this.placeholderElement = element;
    };

    render() {
        const { id, imageSizeType, mode, quality, imageBaseUrl, ...other } = this.props;
        const { minHeight } = this.state;
        let src = null;

        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        if (id && imageBaseUrl) {
            src = RouterService.imageUrl(id, imageBaseUrl, { mode, quality });
        }

        const imageProps = {
            ...other,
            src,
            placeholderProps: {
                minHeight,
            },
            forwardedRef: this.handleImageRef,
        };
        // @ts-expect-error $TSFixMeError: Type '{ rounded: true; src: string | null; placeholderProps: { minHeight: any; }; forwardedRef: (c: any) => any; graysca...
        return <MewsImage {...imageProps} rounded />;
    }
}
